import { Ride, NOT_FOUND_ERR } from './entities';
import { TrackingLoadedAction, LOAD_TRACKING } from './actions';

export interface TrackingState {
    data: Ride | null;
    error: string | null;
    isLoading: boolean;
}

const initialState: TrackingState = {
    data: null,
    error: null,
    isLoading: false,
};

export function trackingReducer(state = initialState, action: TrackingLoadedAction) {
    switch (action.type) {
        case LOAD_TRACKING.LOAD_TRACKING_SUCCESS:
            return {
                ...state,
                error: null,
                data: action.payload,
                isLoading: false,
            };
        case LOAD_TRACKING.LOAD_TRACKINGE_ERROR:
            const newstate = {
                ...state,
                error: action.error,
                isLoading: false,
            };
            if (action.error === NOT_FOUND_ERR) {
                newstate.data = null;
            }
            return newstate;
        case LOAD_TRACKING.LOAD_TRACKING_REQUEST:
            return {
                ...state,
                error: null,
                isLoading: true,
            };
        default:
            return state;
    }
}
